import { createSlice } from '@reduxjs/toolkit';

export const userSlice = createSlice({
    name: 'user',
    initialState: null,
    reducers: {
        userSet: (state, action) => {
            return action.payload;
        }
    }
});

export const { userSet } = userSlice.actions;
export default userSlice.reducer;
